import { Building2, Receipt, TrendingUp, BookOpen, FolderOpen, StickyNote } from 'lucide-react';

export const PROJECT_TABS = [
  { key: 'overview',  label: 'Overview',  icon: Building2 },
  { key: 'costs',     label: 'Costs',     icon: Receipt },
  { key: 'finance',   label: 'Finance',   icon: TrendingUp },
  { key: 'site',      label: 'Site',      icon: BookOpen },
  { key: 'documents', label: 'Documents', icon: FolderOpen },
  { key: 'notes',     label: 'Notes',     icon: StickyNote },
];

/** Sticky tab bar for the Project page. `counts` = { finance, site, notes } badges. */
export function ProjectTabs({ tab, onChange, counts = {} }) {
  return (
    <div
      className="sticky top-0 z-20 bg-[#1E2530]/95 backdrop-blur-md border-b border-white/10 mt-4 mb-6 -mx-1 px-1 flex gap-1 overflow-x-auto"
      role="tablist"
      data-testid="project-tabs"
    >
      {PROJECT_TABS.map(t => {
        const Icon = t.icon;
        const active = tab === t.key;
        const count = counts[t.key];
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.key)}
            className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-all whitespace-nowrap ${
              active ? 'border-[#F5A623] text-[#F5A623] bg-white/5 rounded-t-md font-semibold' : 'border-transparent text-gray-400 hover:text-white hover:border-gray-500'
            }`}
            data-testid={`project-tab-${t.key}`}
          >
            <Icon className="w-4 h-4" />{t.label}
            {count != null && count > 0 && (
              <span className="px-2 py-0.5 text-[11px] font-mono rounded-full bg-white/10 text-gray-300" data-testid={`project-tab-${t.key}-count`}>{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
